import React, { useContext } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import "./accountPage.css";
import { CombinedContext } from "../../context/combinedContext";
import { LogOut, ArrowLeft, ChevronRight } from "lucide-react";
import translations from "../../translations/translations";
import ReactCountryFlag from "react-country-flag";

const BASE_MENU = [
    // { id: "profile", roles: ["customer", "staff", "admin", "owner"], order: 1 },
    { id: "bookings", roles: ["customer"], order: 1 },

    {
        id: "notifications",
        roles: ["customer", "staff", "admin", "owner"],
        order: 2,
    },
    {
        id: "language",
        roles: ["customer", "staff", "admin", "owner"],
        order: 3,
    },
    { id: "security", roles: ["customer", "staff", "admin", "owner"], order: 4 },
    // {
    //     id: "settings",
    //     roles: ["customer", "staff", "admin", "owner"],
    //     order: 4,
    // },
    { id: "privacy", roles: ["customer", "admin", "owner"], order: 5 },
    { id: "terms", roles: ["customer", "admin", "owner"], order: 6},
    { id: "refund", roles: ["customer", "admin", "owner"], order: 7 },
    { id: "helpandsupport", roles: ["customer", "staff", "admin", "owner"], order: 8, comingSoon: true, },
    // { id: "referral", roles: ["owner"], order: 9 },
    { id: "contact", roles: ["customer", "staff", "admin", "owner"], order: 10 },
    {
        id: "reportsandperfomance",
        roles: ["customer", "staff", "admin", "owner"],
        order: 11,
        comingSoon: true,
    },
    {
        id: "marketing",
        roles: ["customer", "staff", "admin", "owner"],
        order: 12,
        comingSoon: true,
    },
    { id: "billing", roles: ["owner"], order: 14},
    { id: "category", roles: ["owner"], order: 10 },

];

const AccountPage = () => {
    const { userData, setUserData, language, setLanguage } =
        useContext(CombinedContext);
    const user = userData?.user || {};
    const role = user?.role;

    const navigate = useNavigate();
    const location = useLocation();

    const currentTab = location.pathname.split("/")[2] || null;
    const isRootAccount = location.pathname === "/account";

    // -------------------------------------------------------------
    // UNIFIED MENU (profile, notifications, security, preferences)
    // -------------------------------------------------------------
    const MENU_ITEMS = BASE_MENU.filter((item) => item.roles.includes(role))
        .sort((a, b) => a.order - b.order)
        .map((item) => ({
            ...item,
            label: translations[language]?.account?.menu[item.id] || item.id,
        }));

    const handleLogout = () => {
        localStorage.removeItem("idToken");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user")
        sessionStorage.removeItem("idToken");
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("refreshToken")
        sessionStorage.removeItem("user")
        sessionStorage.removeItem("shop")
        setUserData(null);
        navigate("/signin");
    };

    return (
        <div className="account-container">
            {/* SIDEBAR */}
            <div
                className={`account-sidebar ${
                    !isRootAccount ? "hide-mobile" : ""
                }`}
            >
                <div className="account-user">
                    <div className="sf-account-page-avatar-wrapper">
                        {user.photo ? (
                            <img
                                src={user.photo}
                                alt=""
                                className="sf-account-page-avatar"
                            />
                        ) : (
                            <div className="sf-avatar-fallback">
                                {user.firstName.charAt(0)}
                            </div>
                        )}
                    </div>
                    <div>
                        <div className="user-name">
                            {user.firstName} {user.lastName}
                        </div>
                        <div className="user-email">{user.email}</div>
                    </div>
                </div>

                {(role === "owner" || role === "staff" || role === "admin") && (
                    <div
                        className="account-referral-feature"
                        onClick={() => navigate("/account/referral")}
                    >
                        <div className="referral-text">
                            <h4>{translations[language].account.menu.referral}</h4>
                            <p>
                                {translations[language].account?.referralSubtitle ||
                                    "Invite other businesses and earn rewards"}
                            </p>
                        </div>

                        <div className="referral-cta">
                            {/* <span></span> */}
                            <ChevronRight/>
                        </div>
                    </div>
                )}

                <div className="account-menu">
                    {MENU_ITEMS.map((item) => (
                        <div
                            key={item.id}
                            className={`menu-item
                            ${currentTab === item.id ? "active" : ""}
                            ${item.comingSoon ? "coming-soon" : ""}
                        `}
                            onClick={() => {
                                if (item.comingSoon) return;
                                navigate(`/account/${item.id}`);
                            }}
                        >
                            <span>{item.label}</span>

                            {item.comingSoon && (
                                <span className="menu-coming-soon">
                                    <span className="menu-coming-soon-sep">·</span>
                                    {translations[language].account?.comingSoon || "Coming soon"}
                                </span>
                            )}

                        </div>
                    ))}

                    <div className="menu-item" onClick={handleLogout}>
                        {/* <LogOut size={18} /> */}
                        <span>
                            {translations[language].account.menu.logout}
                        </span>
                    </div>
                    {/* <div className="menu-item logout" onClick={handleLogout}>
						<LogOut size={18} />
						<span>{translations[language].account.menu.logout}</span>
					</div> */}
                </div>
            </div>

            {/* MOBILE HEADER */}
            {!isRootAccount && (
                <div className="account-mobile-header">
                    <button
                        onClick={() => navigate("/account")}
                        className="mobile-back-btn"
                    >
                        <ArrowLeft size={20} />
                    </button>
                    <h3>
                        {MENU_ITEMS.find((x) => x.id === currentTab)?.label ||
                            "Account"}
                    </h3>
                </div>
            )}

            {/* MAIN CONTENT */}
            <div className="account-content">
                {isRootAccount ? (
                    <div className="empty-state desktop-only">
                        <h2>
                            {translations[language].account.emptyState.title}
                        </h2>
                        <p>
                            {translations[language].account.emptyState.subtitle}
                        </p>
                    </div>
                ) : (
                    <Outlet />
                )}
            </div>
        </div>
    );
};

export default AccountPage;
